import AxiosBaseService from "./axiosBaseService";
import axios from "axios";

export default class AxiosOrgService extends AxiosBaseService {

  // ================ Org ================
  // GET: fetch Org all data, including list out all groups
  getOrgList(token: string) {
    return this.get(`${this.serverUrl}/organization/org`, {authToken: token});
  }

  // POST: create a new Org
  createOrg(token: string, orgData:any) {
    console.log('OrgData: ', orgData);
    return this.post(`${this.serverUrl}/organization/org`, orgData, {
      authToken: token
    });
  }

  // PATCH: update Org data
  updateOrg(token: string, orgId: string, updateData:any) {
    return this.patch(`${this.serverUrl}/organization/org/${orgId}`, updateData, {
      authToken: token
    });
  }

  // PUT: add/remove org_admin
  updateOrgAdmin(token: string, orgId:string, updateData:any) {
    console.log("updateOrgAdmin-updateData: ", updateData)
    return this.put(`${this.serverUrl}/organization/org/${orgId}/user`, updateData, {
      authToken: token
    });
  }
  // ================ Group ================
  //GET: fetch all users under Group 
  getGroupList(token: string) {
    return this.get(`${this.serverUrl}/organization/org/group`, {authToken: token});
  }

  // POST: create a new Org
  createGroup(token: string, orgId:any, updateData:any) {
    return this.post(`${this.serverUrl}/organization/org/${orgId}/group`, updateData, {
      authToken: token
    });
  }

  // PATCH: update Group data
  updateGroup(token: string, orgId:string, groupId:string, updateData:any) {
    return this.patch(`${this.serverUrl}/organization/org/${orgId}/group/${groupId}`, updateData, {
      authToken: token
    });
  }

  // PUT: update users under Group
  updateGroupUser(token: string, orgId:string, groupId:string, updateData:any) {
    return this.put(`${this.serverUrl}/organization/org/${orgId}/group/${groupId}/user`, updateData, {
      authToken: token
    });
  }
  // GET: Users Reports Under The Group
  getReport(token: string, orgId:string, groupId:string) {
    return this.get(`${this.serverUrl}/organization/org/${orgId}/group/${groupId}/reporting`, {authToken: token});
  }
}